<template src="../templates/normal_fcont_166.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppCompatiblePrinters from "../components/AppCompatiblePrinters"
import PrintButton from '../components/PrintButton'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import UseDesignPaperList from '../components/UseDesignPaperList'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '166',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,AppCompatiblePrinters,
    PrintButton,ReleaseDateForArticle,InfoMachineTranslation,UseDesignPaperList
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['166-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['166-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
</style>

